import ImageTemplate from "./ImageTemplate";
import TextTemplate from "./TextTemplate";
import GreetingTemplate from "./GreetingTemplate";
import ThankYouTemplate from "./ThankYouTemplate";
import VideoTemplate from "./VideoTemplate";
import MultipleChoiceTemplate from "./MultipleChoiceTemplate";
import DocumentTemplate from "./DocumentTemplate";
import AudioTemplate from "./AudioTemplate";

class TemplateManager {
    constructor() {
        this.templates = [];
        this.startTemplate = new GreetingTemplate();
        this.templates.push(new TextTemplate());
        this.templates.push(new ImageTemplate());
        this.templates.push(new VideoTemplate());
        this.templates.push(new MultipleChoiceTemplate());
        this.templates.push(new DocumentTemplate());
        this.templates.push(new AudioTemplate());
        this.finishTemplate = new ThankYouTemplate();
    }

    findByType(type) {
        if (type === this.startTemplate.type()) {
            return this.startTemplate;
        }
        if (type === this.finishTemplate.type()) {
            return this.finishTemplate;
        }
        return this.templates.find((item) => {
            if (item.type() === type) {
                return true;
            }
            return false;
        });
    }
}

const templateManager = new TemplateManager();

export default templateManager;
